import {
  alpha,
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid2,
  Grow,
  IconButton,
  InputLabel,
  Paper,
  Popover,
  Snackbar,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useGetCandidateCommissionListMutation, useInvoiceUpdateByHistoryMutation } from "../../redux/candidateprofiles/candidateprofiles.api";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import dayjs from "dayjs";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Collapse from "@mui/material/Collapse";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import _ from "lodash";
import "../ReferralPayments/viewJobPayment.css";
import {
  useCommissionApproveMutation,
  useReferralCommissionApprovalMutation,
  useReferralCommissionRejectedAndHoldMutation,
  useRefundReturnAmountUpdateMutation,
  useRefundReturnByIdMutation,
  useUpdatePaymentStatusMutation,
} from "../../redux/ReferralPayment/ViewCandidatePayment.api";
import DeleteIcon from "../../assets/deleteIcon.png";
import MUIButton from "../../reusable_components/components/MUIButton";
import CloseIcon from "@mui/icons-material/Close";
import { PaymentLoader } from "../../reusable_components/components/PaymentLoader";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import { SimpleCommissionLoader } from "../clients/ViewClients";
import { AttachMoney, Business, EditOff, Email, TrendingUp } from "@mui/icons-material";
import { useTheme } from "@emotion/react";
import {
  CheckCircle,
  Cancel,
  PauseCircle,
  Work
} from '@mui/icons-material';
import { useFetchPaymentHistoryMutation } from "../../redux/commissionManagement/commissionManagement.api";
import { LuHistory } from "react-icons/lu";
import { TableLoader } from "../../reusable_components/components/TableLoader";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';


const ViewCommissions = () => {
  const theme = useTheme();
  const statusConfig = {
    active: { color: 'success', label: 'Active' },
    interviewing: { color: 'warning', label: 'Interviewing' },
    offered: { color: 'info', label: 'Offered' },
    placed: { color: 'success', label: 'Placed' },
    rejected: { color: 'error', label: 'Rejected' }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(amount);
  };

  const location = useLocation();
  const navigate = useNavigate();
  const {
    profileId,
    candidateName,
    candidateAnnualSalary,
    companyCommission,
    positionName,
    candidateEmail,
    clientName,
    positionId,
    commissionStatus,
    overAllStatus,
    commissionManagementId,
  } = location?.state || "";

  const { Snackbar } = useContext(SnackbarContext);

  const [showLoader, setShowLoader] = useState(false);
  const [commissionDetails, setCommissionDetails] = useState([]);
  const [collectDialog, setCollectDialog] = useState(false);
  const [refundReturn, setRefundReturn] = useState([]);
  const [invoiceNoError, setInvoiceNoError] = useState("");
  const [history, setHistory] = useState([])
  const [openHistory, setOpenHistory] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState("");
  const [updatedInvoice, setUpdatedInvoice] = useState("");
  const [historyId, setHistoryId] = useState()

  // API
  const [candidateCommissions] = useGetCandidateCommissionListMutation();
  const [updatePaymentStatus] = useUpdatePaymentStatusMutation();
  const [collectAmount] = useRefundReturnByIdMutation();
  const [savecollect] = useRefundReturnAmountUpdateMutation();
  const [referralCommissionApproval] = useCommissionApproveMutation();
  const [commissionRejectAndHold] = useReferralCommissionRejectedAndHoldMutation();
  const [getHistory] = useFetchPaymentHistoryMutation();
  const [updateInovoice] = useInvoiceUpdateByHistoryMutation()

  const getCommissionDetails = async () => {
    setShowLoader(true);
    try {
      const payload = {
        profileId: +profileId,
        positionId: positionId,
        commissionManagementId: commissionManagementId,
      };
      const response = await candidateCommissions(payload).unwrap();
      setCommissionDetails(response?.response);
      setShowLoader(false)
    } catch (error) {
      Snackbar("Network error", "error");
      setShowLoader(false)
    }
  };

  const handleCollectRefund = async (installmentId) => {
    setCollectDialog(true);
    try {
      const payload = {
        referralCommissionPaymentId: installmentId,
      };

      const response = await collectAmount(payload).unwrap();
      setRefundReturn(response?.response);
    } catch (error) {
      Snackbar("Network error", "error");
    }
  };

  const handleCollectAmount = async (refundAmount, id, no) => {
    if (!invoiceNumber) {
      Snackbar('Please Enter Invoice Number', 'error')
      return;
    }
    try {
      const params = {
        referralCommissionPaymentId: id,
        refundReturnAmount: refundAmount,
        invoiceNo: invoiceNumber,
      };
      setPaymentLoader(true);
      const response = await savecollect(params).unwrap();
      if (response?.response?.status === "success") {
        Snackbar(response?.response?.message, "success");
        getCommissionDetails();
        setCollectDialog(false);
        setPaymentLoader(false);
        setIsRefundChecked(false);
      } else if (response?.response?.status === "error") {
        Snackbar("The refunded amount has not been updated.", "error");
        setPaymentLoader(false);
      }
    } catch (error) {
      Snackbar("Network error", "error");
      setPaymentLoader(false);
    }
  };

  useEffect(() => {
    getCommissionDetails();
  }, []);

  const handleNavigation = () => {
    navigate("/referral-payments", {
      state: {
        commissionManagementId: commissionManagementId
      }
    });
  };

  const [openWarningDialog, setOpenWarningDialog] = useState(false);
  const [confirmResolve, setConfirmResolve] = useState(null);
  const [reason, setReason] = useState("");
  const [paymentLoader, setPaymentLoader] = useState(false);
  const [isRefundChecked, setIsRefundChecked] = useState(false);
  const [invoiceNumber, setInvoiceNumber] = useState('')

  const handleGetInvoiceId = (e) => {
    setInvoiceNumber(e.target.value)
  }

  const handleReason = (e) => {
    setReason(e.target.value);
    setIsReason(false);
  };

  const handleCloseWarining = () => {
    setOpenWarningDialog(false);
    setReason("");
    setIsReason(false);
    setInvoiceNumber("")
  };


  const [status, setStatus] = useState("");

  const waitingForApproval = (status) => {
    setStatus(status);
    setOpenWarningDialog(true);
    return new Promise((resolve) => {
      setConfirmResolve(() => resolve);
    });
  };

  const [isReason, setIsReason] = useState(false);

  const handleDeclinePayment = () => {
    if (reason === "") {
      setIsReason(true);
    } else {
      if (confirmResolve) confirmResolve({ confirmed: true, reason });
      setOpenWarningDialog(false);
    }
  };

  const handleCloseCollect = () => {
    setIsRefundChecked(false);
    setCollectDialog(false);
    setInvoiceNumber("")
  };

  const paymentStatus = async (installments, status) => {
    const confirmation = await waitingForApproval(status);

    if (confirmation) {
      try {
        const params = {
          paymentCommissionId: installments?.ReferralCommissionPaymentId,
          status: status,
          feedBackORInvoiceId: confirmation?.reason || "",
        };
        setPaymentLoader(true);
        const response = await updatePaymentStatus(params).unwrap();
        if (response?.status === 200) {
          getCommissionDetails();
          setReason("");

          const time = setTimeout(() => {
            setPaymentLoader(false);
            Snackbar(response?.response, "success");
          }, 500);

          return () => clearInterval(time);
        }
      } catch (error) {
        setReason("");
        setPaymentLoader(false);
        console.error("Error while changing the staus");
        Snackbar("Network error", "error");
      }
    }
  };

  const getCommissionIds = commissionDetails?.referralCommissionDetails?.map(
    (item) => item?.referralCommissionId
  );

  const handleApproveCommission = async () => {
    try {
      const payload = {
        referralCommissionIds: getCommissionIds || [],
      };

      const response = await referralCommissionApproval(payload).unwrap();
      Snackbar("Commission Approved Successfully", "success");
      getCommissionDetails();
    } catch (error) {
      Snackbar("Network error", "error");
    }
  };

  const [openGetReason, setOpenGetReason] = useState(false);
  const [commissionsStatus, setCommissionsStatus] = useState("");

  const handleRejectAndHold = (value) => {
    setOpenGetReason(true);
    setCommissionsStatus(value);
  };

  const handleCloseReasonDialog = () => {
    setOpenGetReason(false);
    setCommissionsStatus("");
    setReason("");
  };

  const handleChangeCommissionStatus = async () => {
    if (!reason) {
      setIsReason(true);
    } else {
      try {
        const payload = {
          referralCommissionIds: getCommissionIds || [],
          status: commissionsStatus,
          remarks: reason,
        };

        const response = await commissionRejectAndHold(payload).unwrap();
        Snackbar(response?.response?.message, "success");
        handleCloseReasonDialog();
        getCommissionDetails();
      } catch (error) {
        Snackbar("Network error", "error");
      }
    }
  };

  const statusOfCommission = commissionDetails?.commonStatusKey;

  const ActionButton = ({
    title,
    onClick,
    variant = "outlined",
    color = "primary",
    startIcon,
    sx = {}
  }) => (
    <Button
      variant={variant}
      color={color}
      onClick={onClick}
      startIcon={startIcon}
      size="small"
      sx={{
        borderRadius: 2,
        textTransform: 'none',
        fontWeight: 600,
        fontSize: '0.75rem',
        px: 2,
        py: 0.5,
        minWidth: 'auto',
        ...sx
      }}
    >
      {title}
    </Button>
  );

  const StatusChip = ({ status }) => {
    const statusConfig = {
      'Approved': { color: 'success', label: 'Approved', icon: <CheckCircle /> },
      'Rejected': { color: 'error', label: 'Rejected', icon: <Cancel /> },
      'Hold': { color: 'warning', label: 'On Hold', icon: <PauseCircle /> },
      'Pending': { color: 'default', label: 'Pending Review', icon: <PauseCircle /> }
    };
    const config = statusConfig[status] || statusConfig['Pending'];
    return (
      <Chip
        icon={config.icon}
        label={config.label}
        color={config.color}
        variant="filled"
        size="small"
        sx={{
          fontWeight: 600,
          fontSize: '0.7rem',
          height: 24
        }}
      />
    );
  };

  const [ReferralCommissionPaymentId, setReferralCommissionPaymentId] = useState()

  const handleGetCommissionHistory = async (item) => {
    setOpenHistory(true)
    setShowLoader(true)
    setReferralCommissionPaymentId(item?.ReferralCommissionPaymentId || ReferralCommissionPaymentId)
    try {
      const payload = {
        referralCommissionPaymentId: item?.ReferralCommissionPaymentId || ReferralCommissionPaymentId
      }

      const res = await getHistory(payload).unwrap()
      setHistory(res?.response)
      setShowLoader(false)
    } catch (error) {
      Snackbar('Netwrok error', 'error')
      console.error("Failed to fetch history");
      setShowLoader(false)
    }
  }

  const handleCloseHistory = () => {
    setOpenHistory(false)
    setHistory([])
  }

  const StatusBadge = ({ status }) => {
    const statusConfig = {
      pending: { color: "#F79009", bgColor: "#FFFAEB" },
      paid: { color: "#3ebe82ff", bgColor: "#ECFDF3" },
      approved: { color: "#12B76A", bgColor: "#ECFDF3" },
      rejected: { color: "#F04438", bgColor: "#FEF3F2" },
      refunded: { color: "#7F56D9", bgColor: "#F9F5FF" },
      rra: { color: "#ba2828ff", bgColor: "#f7f2f2ff" },
      default: { color: "#667085", bgColor: "#F2F4F7" },
    };

    const config = statusConfig[status?.toLowerCase()] || statusConfig.default;

    return (
      <Chip
        label={status === "RRA" ? "Refund & Return" : status}
        size="small"
        sx={{
          backgroundColor: config.bgColor,
          color: config.color,
          fontWeight: 600,
          fontSize: '0.75rem',
          border: `1px solid ${config.color}30`,
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'translateY(-1px)',
            boxShadow: `0 4px 12px ${alpha(config.color, 0.2)}`,
          },
        }}
      />
    );
  };

  const handleOpen = (event, item) => {
    setAnchorEl(event.currentTarget);
    setSelectedInvoice(item?.invoiceNumber);
    setUpdatedInvoice(item?.invoiceNumber);
    setHistoryId(item?.id)
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleUpdateInoive = async () => {
    if (!updatedInvoice) {
      Snackbar('Please enter updated invoice id', 'error')
      return
    }
    const params = {
      paymentHistoryId: historyId,
      invoiceNo: updatedInvoice
    }
    try {
      const res = await updateInovoice(params).unwrap()
      if (res?.status === 200) {
        Snackbar(res?.response?.status, 'success');
        setAnchorEl(null)
        handleGetCommissionHistory()
      }
    } catch (error) {
      console.error('error occurred', error);
      Snackbar('Network error', 'error')
    }
  }

  return (
    <Box className="container">
      {paymentLoader ? <PaymentLoader /> : ""}
      <Grid2
        item
        sx={{
          display: "flex",
          alignItems: "center",
          color: "#6941C6",
          gap: "4px",
          cursor: "pointer",
          width: "40px",
          marginBottom: "20px",
        }}
        onClick={handleNavigation}
      >
        <ArrowBackIcon sx={{ fontSize: "17px" }} />
        <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>Back</Typography>
      </Grid2>
      <Grid2>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            p: 3,
            mb: 2,
            backgroundColor: 'white',
            borderRadius: 3,
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            border: `1px solid ${theme.palette.divider}`,
            transition: 'all 0.3s ease',
            gap: 3,
            '&:hover': {
              boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
              borderColor: theme.palette.primary.light,
            }
          }}
        >
          <Box
            sx={{
              width: 60,
              height: 60,
              borderRadius: '50%',
              background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontWeight: 700,
              fontSize: '1.2rem',
              flexShrink: 0
            }}
          >
            {candidateName.split(' ').map(n => n[0]).join('')}
          </Box>

          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <Box sx={{ display: 'flex', flexDirection: 'row', gap: 5, justifyContent: 'space-evenly', alignItems: 'center' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: '1.2rem',
                      color: 'text.primary',
                      lineHeight: 1.2
                    }}
                  >
                    {candidateName}                <StatusChip status={statusOfCommission} />

                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Email sx={{ fontSize: 16, color: 'primary.main' }} />
                    <Typography
                      sx={{
                        fontWeight: 500,
                        fontSize: '0.9rem',
                        color: 'primary.main'
                      }}
                    >
                      {candidateEmail}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Work sx={{ fontSize: 18, color: 'text.primary' }} />
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: '1rem',
                      color: 'text.primary'
                    }}
                  >
                    {positionName}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Business sx={{ fontSize: 16, color: 'text.secondary' }} />
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: '0.9rem',
                      color: 'text.secondary'
                    }}
                  >
                    {clientName}
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* Bottom Row - Financial Info & Actions */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {/* Financial Information */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                {/* Annual Salary */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Box sx={{
                    width: 32,
                    height: 32,
                    borderRadius: '50%',
                    backgroundColor: 'success.light',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <AttachMoney sx={{ fontSize: 16, color: 'success.main' }} />
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontSize: '0.7rem',
                        color: 'text.secondary',
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}
                    >
                      Annual Salary
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: '1rem',
                        color: 'success.main'
                      }}
                    >
                      {formatCurrency(candidateAnnualSalary)}
                    </Typography>
                  </Box>
                </Box>

                {/* Commission */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Box sx={{
                    width: 32,
                    height: 32,
                    borderRadius: '50%',
                    backgroundColor: 'warning.light',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <TrendingUp sx={{ fontSize: 16, color: 'warning.main' }} />
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontSize: '0.7rem',
                        color: 'text.secondary',
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}
                    >
                      Commission
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: '1rem',
                        color: 'warning.main'
                      }}
                    >
                      {formatCurrency(companyCommission)}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              {statusOfCommission !== "Approved" && !showLoader && (
                <Box sx={{ display: 'flex', gap: 1 }}>
                  {statusOfCommission !== "Approved" && statusOfCommission !== "Rejected" && (
                    <ActionButton
                      title="Approve"
                      onClick={handleApproveCommission}
                      startIcon={<CheckCircle />}
                      sx={{
                        backgroundColor: '#ECFDF3',
                        color: '#067647',
                        border: '1px solid #ABEFC6',
                        '&:hover': {
                          backgroundColor: '#D1FADF',
                        }
                      }}
                    />
                  )}

                  {statusOfCommission !== "Rejected" && statusOfCommission !== "Approved" && (
                    <ActionButton
                      title="Reject"
                      onClick={() => handleRejectAndHold("Rejected")}
                      startIcon={<Cancel />}
                      sx={{
                        backgroundColor: '#FEF3F2',
                        color: '#D92D20',
                        border: '1px solid #FECDCA',
                        '&:hover': {
                          backgroundColor: '#FEE4E2',
                        }
                      }}
                    />
                  )}

                  {statusOfCommission !== "Hold" && statusOfCommission !== "Rejected" && statusOfCommission !== "Approved" && (
                    <ActionButton
                      title="Hold"
                      onClick={() => handleRejectAndHold("Hold")}
                      startIcon={<PauseCircle />}
                      sx={{
                        backgroundColor: '#FFFAEB',
                        color: '#B54708',
                        border: '1px solid #FEDF89',
                        '&:hover': {
                          backgroundColor: '#FEF0C7',
                        }
                      }}
                    />
                  )}
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Grid2>

      <Grid2 container spacing={3}>
        {commissionDetails?.referralCommissionDetails?.map((item, index) => (
          <Grow
            in={true}
            timeout={500 * (index + 1)}
            key={index}
            sx={{ width: "100%" }}
          >
            <Grid2 item xs={12}>
              <Typography
                sx={{
                  fontFamily: "Robotic",
                  fontSize: "17px",
                  fontWeight: 600,
                  color: "#757367",
                }}
              >
                {item?.referralType === "JOB-REF"
                  ? "Job Referral Commission"
                  : item?.referralType === "CAN-REF"
                    ? "Candidate Referral Commission"
                    : "Client Referral Commission"}
              </Typography>
              <Paper
                elevation={12}
                sx={{
                  p: 3,
                  borderRadius: 3,
                  borderLeft: "6px solid #7b2cbf",
                  background:
                    "linear-gradient(to bottom right, #ffffff, #f8f9fa)",
                  transition: "transform 0.3s",
                  "&:hover": { transform: "scale(1.015)" },
                }}
              >
                <Grid2
                  container
                  spacing={2}
                  sx={{ display: "flex", justifyContent: "space-around" }}
                >
                  <Grid2 item xs={12} sm={6} md={3}>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color="secondary"
                    >
                      Referred By:
                    </Typography>
                    <Typography variant="body2">
                      {item.referredByUser}
                    </Typography>
                  </Grid2>
                  <Grid2 item xs={12} sm={6} md={3}>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color="secondary"
                    >
                      Reward Type:
                    </Typography>
                    <Typography variant="body2">
                      {item.commissionType === "FC"
                        ? "Fixed Amount"
                        : "Fixed Percentage"}
                    </Typography>
                  </Grid2>
                  <Grid2 item xs={12} sm={6} md={3}>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color="secondary"
                    >
                      Reward :
                    </Typography>
                    {item.commissionType === "FC" ? (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <CurrencyRupeeIcon
                          sx={{ fontSize: "14px", color: "#a6aba5" }}
                        />
                        <Typography sx={{ fontSize: "12.5px" }}>
                          {item?.fixedCommissionPrice}
                        </Typography>
                      </Box>
                    ) : (
                      <Typography sx={{ fontSize: "12.5px" }}>
                        {item?.fixedCommissionPercentage}%
                      </Typography>
                    )}
                  </Grid2>
                  <Grid2 item xs={12} sm={6} md={3}>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color="secondary"
                    >
                      Total Reward:
                    </Typography>
                    <Typography variant="body2">
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <CurrencyRupeeIcon
                          sx={{ fontSize: "14px", color: "#a6aba5" }}
                        />
                        <Typography sx={{ fontSize: "12.5px" }}>
                          {item?.commissionAmount}
                        </Typography>
                      </Box>
                    </Typography>
                  </Grid2>

                  {/* <Grid2 item xs={12} sm={6} md={3}>
                                        <Typography variant="body1" fontWeight="bold" color="secondary">Status </Typography>
                                        <Typography variant="body2">Active</Typography>
                                    </Grid2> */}
                </Grid2>

                <Divider sx={{ my: 2 }} />

                <Typography
                  variant="subtitle1"
                  sx={{ color: "#5e548e", fontWeight: "bold" }}
                >
                  Installment Details
                </Typography>
                {item?.installments && item.installments.length > 0 ? (
                  <>
                    <Grid2
                      mt={1}
                      sx={{ display: "flex", }}
                    >
                      <Grid2
                        sx={{
                          width: "20%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Typography sx={{ color: "#717680" }}>
                          Payment Id
                        </Typography>
                      </Grid2>
                      <Grid2
                        sx={{
                          width: "20%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Typography sx={{ color: "#717680" }}>
                          Due Date
                        </Typography>
                      </Grid2>
                      <Grid2
                        sx={{
                          width: "20%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Typography sx={{ color: "#717680" }}>
                          Amount
                        </Typography>
                      </Grid2>
                      <Grid2
                        sx={{
                          width: "20%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Typography sx={{ color: "#717680" }}>
                          Status
                        </Typography>
                      </Grid2>
                      <Grid2
                        sx={{
                          width: "20%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Typography sx={{ color: "#717680" }}>
                          Action
                        </Typography>
                      </Grid2>
                      <Grid2
                        sx={{
                          width: "20%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Typography sx={{ color: "#717680" }}>
                          View History
                        </Typography>
                      </Grid2>
                    </Grid2>

                    {/* Installments Data */}
                    {item.installments.map((installments, index) => (
                      <Grid2
                        key={installments?.ReferralCommissionPaymentId}
                        mt={1}
                        sx={{ display: "flex", }}
                      >
                        <Grid2
                          sx={{
                            width: "20%",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Typography sx={{ fontFamily: "Georiga" }}>
                            {installments?.ReferralCommissionPaymentId}
                          </Typography>
                        </Grid2>
                        <Grid2
                          sx={{
                            width: "20%",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Typography sx={{ fontFamily: "Georiga" }}>
                            {dayjs(installments?.paymentDate).format(
                              "DD-MM-YYYY"
                            )}
                          </Typography>
                        </Grid2>
                        <Grid2
                          sx={{
                            width: "20%",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Typography sx={{ fontFamily: "Georiga" }}>
                            {installments?.paymentAmount}
                          </Typography>
                        </Grid2>
                        <Grid2
                          sx={{
                            width: "20%",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Typography>
                            <StatusBadge status={installments?.paymentStatus} />
                          </Typography>
                        </Grid2>
                        {index === 0 && (
                          <Grid2
                            sx={{
                              width: "20%",
                              display: "flex",
                              justifyContent: "center",
                              flexDirection: "row",
                              gap: 1,
                            }}
                          >
                            {installments?.paymentStatus === "Pending" ? (
                              <>
                                <Box
                                  sx={{
                                    width: "80%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                  gap={3}
                                >
                                  <Button
                                    fullWidth
                                    variant="contained"
                                    color="success"
                                    size="small"
                                    onClick={() =>
                                      paymentStatus(installments, "Paid")
                                    }
                                  >
                                    Pay
                                  </Button>
                                  <Button
                                    fullWidth
                                    variant="outlined"
                                    sx={{
                                      borderColor: "#EB1313",
                                      color: "#EB1313",
                                    }}
                                    size="small"
                                    onClick={() =>
                                      paymentStatus(installments, "Rejected")
                                    }
                                  >
                                    Reject
                                  </Button>
                                </Box>
                              </>
                            ) : installments?.paymentStatus === "Paid" ? (
                              <Button
                                variant="outlined"
                                // color="#FF9100"
                                size="small"
                                sx={{
                                  width: "80%",
                                  color: "#FF9100",
                                  borderColor: "#FF9100",
                                  fontSize: "12px",
                                  whiteSpace: "nowrap",
                                }}
                                disabled={
                                  item.installments[1]?.paymentStatus === "Paid"
                                }
                                onClick={
                                  item.installments[1]?.paymentStatus === "Paid"
                                    ? null
                                    : () =>
                                      paymentStatus(installments, "Refund")
                                }
                              >
                                {item.installments[1]?.paymentStatus === "Paid"
                                  ? "Closed"
                                  : "Refund & Reject"}
                              </Button>
                            ) : installments?.paymentStatus === "Rejected" ? (
                              <Button
                                variant="outlined"
                                color="error"
                                size="small"
                                disabled
                                onClick={() =>
                                  paymentStatus(installments, "Refund")
                                }
                                sx={{
                                  textTransform: "none",
                                  width: "80%",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                🚫 Action Prevented
                              </Button>
                            ) : installments?.paymentStatus === "Refund" ? (
                              <Button
                                variant="contained"
                                color="success"
                                size="small"
                                onClick={() =>
                                  handleCollectRefund(
                                    installments?.ReferralCommissionPaymentId
                                  )
                                }
                                startIcon={<CurrencyExchangeIcon />}
                                sx={{
                                  textTransform: "none",
                                  width: "80%",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Collect Amount
                              </Button>
                            ) : (
                              <Button
                                variant="outlined"
                                color="error"
                                size="small"
                                disabled
                                onClick={() =>
                                  paymentStatus(installments, "Rejected")
                                }
                                sx={{
                                  textTransform: "none",
                                  width: "80%",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                🚫 Action Prevented
                              </Button>
                            )}
                          </Grid2>
                        )}
                        {index === 1 && (
                          <Grid2
                            sx={{
                              width: "20%",
                              display: "flex",
                              justifyContent: "center",
                              flexDirection: "row",
                              gap: 1,
                            }}
                          >
                            {installments?.paymentStatus === "Pending" ? (
                              <>
                                <Button
                                  variant="contained"
                                  color="success"
                                  size="small"
                                  disabled={
                                    item.installments[0]?.paymentStatus !==
                                    "Paid"
                                  }
                                  onClick={() =>
                                    paymentStatus(installments, "Paid")
                                  }
                                  sx={{ width: "80%" }}
                                >
                                  Pay
                                </Button>
                              </>
                            ) : installments?.paymentStatus === "Paid" ? (
                              <Button
                                variant="outlined"
                                // color="#FF9100"
                                size="small"
                                sx={{
                                  width: "80%",
                                  color: "#FF9100",
                                  borderColor: "#FF9100",
                                }}
                                disabled={
                                  item.installments[1]?.paymentStatus === "Paid"
                                }
                                onClick={() =>
                                  paymentStatus(installments, "Refund")
                                }
                              >
                                Closed
                              </Button>
                            ) : installments?.paymentStatus === "Rejected" ? (
                              // <Button
                              //     variant="outlined"
                              //     color="error"
                              //     size="small"
                              //     disabled
                              //     onClick={() => paymentStatus(installments, 'Refund')}
                              //     sx={{ textTransform: 'none', width: '60%' }}
                              // >
                              //     🚫 Action Prevented
                              // </Button>
                              <></>
                            ) : installments?.paymentStatus === "Refund" ? (
                              <Button
                                variant="outlined"
                                // color="error"
                                size="small"
                                // disabled
                                // onClick={() => paymentStatus(installments, 'Rejected')}
                                onClick={() => setCollectDialog(true)}
                                sx={{
                                  textTransform: "none",
                                  width: "80%",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Collect Amount
                              </Button>
                            ) : (
                              <Button
                                variant="outlined"
                                color="error"
                                size="small"
                                disabled
                                onClick={() =>
                                  paymentStatus(installments, "Rejected")
                                }
                                sx={{
                                  textTransform: "none",
                                  width: "80%",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                🚫 Action Prevented
                              </Button>
                            )}
                          </Grid2>
                        )}
                        <Grid2
                          sx={{
                            width: "20%",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Tooltip
                            title="Payment History"
                            placement="top"
                            slotProps={{
                              tooltip: {
                                sx: {
                                  backgroundColor: "#0A0D12",
                                  borderRadius: "8px",
                                  padding: "8px 12px",
                                  boxShadow:
                                    "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                },
                              },
                            }}
                          >
                            <span>
                              <LuHistory
                                onClick={() => handleGetCommissionHistory(installments)}
                                style={{
                                  fontSize: "17px",
                                  margin: "5px",
                                  cursor: "pointer",
                                  color: "#b6bbbb",
                                  transition: "transform 0.2s ease, color 0.2s ease",
                                }}
                                onMouseOver={(e) => {
                                  e.currentTarget.style.color = "#5417cd";
                                  e.currentTarget.style.transform =
                                    "scale(1.2)";
                                }}
                                onMouseOut={(e) => {
                                  e.currentTarget.style.color = "#b6bbbb";
                                  e.currentTarget.style.transform =
                                    "scale(1)";
                                }}
                              />
                            </span>
                          </Tooltip>
                        </Grid2>
                      </Grid2>
                    ))}
                  </>
                ) : (
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Typography sx={{ color: "#000", fontSize: "14px" }}>
                      No Data Found
                    </Typography>
                  </Box>
                )}
              </Paper>
            </Grid2>
          </Grow>
        ))}
      </Grid2>
      {/* <Grid2 item>
                <Dialog

                    scroll="paper"
                    maxWidth="xs"
                    sx={{
                        "& .MuiDialog-paper": {
                            width: '90%',
                            maxWidth: '550px',
                            height: 'auto',
                            borderRadius: '15px'
                        },
                    }}
                >
                    <DialogContent>
                        <DialogContentText>
                            <div style={{ display: 'flex', gap: '12px', marginTop: '7px' }}>

                                <div>
                                    <Typography sx={{ color: '#181D27', fontWeight: 600, fontSize: '17px' }}>Confirmation ?</Typography>
                                    <Typography sx={{ color: '#535862', fontWeight: 400, fontSize: '14px' }}>
                                        Are you sure you want to decline the payment? This action cannot be undone.
                                    </Typography>
                                </div>
                            </div>
                            <Grid2 item sx={{ marginTop: '25px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                <MUICancelButton title='Cancel' onClick={() => setOpenWarningDialog(false)} />
                                <MUIButton title='DECLINE' onClick={handleDeclinePayment} sx={{ backgroundColor: '#D92D20', borderRadius: '10px', cursor: 'pointer' }} />
                            </Grid2>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>
            </Grid2> */}
      <Grid2>
        <Dialog
          open={openWarningDialog}
          onClose={handleCloseWarining}
          scroll="paper"
          maxWidth="sm"
          sx={{
            "& .MuiDialog-paper": {
              minWidth: "40vw",
              minHeight: "auto",
            },
          }}
        >
          <DialogTitle
            dividers
            sx={{
              fontWeight: "bold",
              alignItems: "center",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <InputLabel className="inputlabels" sx={{ fontWeight: 600 }}>
              {" "}
              {status === "Paid"
                ? "Enter Invoice No"
                : "Reason for Cancellation"}{" "}
              <span style={{ color: "red" }}>*</span>
            </InputLabel>
            <CloseIcon
              sx={{ cursor: "pointer", color: "#A4A7AE" }}
              onClick={handleCloseWarining}
            />
          </DialogTitle>
          <DialogContent sx={{ padding: "20px" }}>
            <textarea
              value={reason}
              onChange={handleReason}
              placeholder={
                status === "Paid" ? "Enter Invoice No" : "Enter Reason"
              }
              className="textareas"
              style={{
                width: "100%",
                height: status === "Paid" ? "40px" : "130px",
              }}
            />
            {isReason && (
              <span style={{ color: "red", fontSize: "0.8rem" }}>
                {" "}
                {status === "Paid"
                  ? "Invoice No is required"
                  : "Reason is required"}
              </span>
            )}
          </DialogContent>

          <DialogActions
            sx={{ justifyContent: "flex-end", paddingBottom: "16px" }}
          >
            <Button
              variant="outlined"
              size="small"
              onClick={handleCloseWarining}
              sx={{
                marginRight: "10px",
                borderColor: "#a2a2a2",
                color: "#a2a2a2",
                textTransform: "none",
              }}
            >
              CANCEL
            </Button>
            <Button
              variant={status === "Paid" ? "contained" : "outlined"}
              color={
                status === "Paid"
                  ? "success"
                  : status === "Rejected"
                    ? "warning"
                    : "error"
              }
              size="small"
              onClick={handleDeclinePayment}
              sx={{
                marginRight: "10px",
                borderColor:
                  status === "Paid"
                    ? "success"
                    : status === "Rejected"
                      ? "#EB1313"
                      : "#FF9100",
                color:
                  status === "Paid"
                    ? "#fffff"
                    : status === "Rejected"
                      ? "#EB1313"
                      : "#FF9100",
              }}
            >
              {status === "Paid"
                ? "Pay"
                : status === "Rejected"
                  ? "Reject"
                  : "Refund & Reject"}
            </Button>
          </DialogActions>
        </Dialog>
      </Grid2>
      <Grid2>
        <Dialog
          open={collectDialog}
          onClose={handleCloseCollect}
          scroll="paper"
          maxWidth="sm"
          sx={{
            "& .MuiDialog-paper": {
              minWidth: "40vw",
              minHeight: "auto",
              borderRadius: "8px",
            },
          }}
        >
          <DialogTitle
            dividers
            sx={{
              fontWeight: "bold",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px 24px",
              backgroundColor: "#f5f5f5",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Refund and Rejection of Amount{" "}
              <span style={{ color: "red" }}>*</span>
            </Typography>
            <IconButton onClick={handleCloseCollect} sx={{ padding: 0 }}>
              <CloseIcon sx={{ color: "#A4A7AE" }} />
            </IconButton>
          </DialogTitle>

          <DialogContent sx={{ padding: "20px 24px", margin: "20px 0px" }}>
            <Grid2 container sx={{ display: "flex", flexDirection: "column" }}>
              <Grid2
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "20px",
                }}
              >
                <Typography variant="body1" sx={{ fontWeight: 500, mr: 1 }}>
                  Refund Amount:
                </Typography>
                <Typography variant="body1">
                  {refundReturn?.refundAmount}
                </Typography>
              </Grid2>

              <Grid2
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography variant="body1" noWrap>
                  Invoice No :
                </Typography>
                <TextField
                  name="invoiceNo"
                  // label="Invoice No"
                  // variant="filled"
                  size="small"
                  value={invoiceNumber}
                  onChange={handleGetInvoiceId}
                  error={!!invoiceNoError}
                  helperText={invoiceNoError}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "4px",
                    },
                    marginLeft: "10px",
                    width: "250px",
                  }}
                />
              </Grid2>
              <Grid2
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                marginTop={"20px"}
              >
                <Checkbox
                  checked={isRefundChecked}
                  onChange={(e) => setIsRefundChecked(e.target.checked)}
                  inputProps={{ "aria-label": "Refund amount checkbox" }}
                  sx={{ padding: 0, marginRight: "8px" }}
                />
                <Typography>Please verify your refund amount once.</Typography>
              </Grid2>
            </Grid2>
          </DialogContent>

          <DialogActions
            sx={{
              padding: "16px 24px",
              borderTop: "1px solid #e0e0e0",
              justifyContent: "flex-end",
            }}
          >
            <Button
              variant="outlined"
              size="medium"
              onClick={handleCloseCollect}
              sx={{
                mr: 2,
                textTransform: "none",
                color: "#616161",
                borderColor: "#e0e0e0",
                "&:hover": {
                  borderColor: "#bdbdbd",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="success"
              size="medium"
              onClick={() => {
                handleCollectAmount(
                  refundReturn?.refundAmount,
                  refundReturn?.referralCommissionPaymentId,
                  refundReturn?.invoiceNumber
                );
              }}
              disabled={isRefundChecked === false}
              sx={{
                textTransform: "none",
                backgroundColor: "#4caf50",
                "&:hover": {
                  backgroundColor: "#3d8b40",
                },
              }}
            >
              Collect
            </Button>
          </DialogActions>
        </Dialog>
      </Grid2>

      <Grid2>
        <Dialog
          open={openGetReason}
          onClose={handleCloseReasonDialog}
          scroll="paper"
          maxWidth="sm"
          sx={{
            "& .MuiDialog-paper": {
              minWidth: "40vw",
              minHeight: "auto",
            },
          }}
        >
          <DialogTitle
            dividers
            sx={{
              fontWeight: "bold",
              alignItems: "center",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <InputLabel className="inputlabels" sx={{ fontWeight: 600 }}>
              Reason
            </InputLabel>
            <CloseIcon
              sx={{ cursor: "pointer", color: "#A4A7AE" }}
              onClick={handleCloseReasonDialog}
            />
          </DialogTitle>
          <DialogContent sx={{ padding: "20px" }}>
            <textarea
              value={reason}
              onChange={handleReason}
              placeholder={"Enter Reason"}
              className="textareas"
              style={{
                width: "100%",
                height: "130px",
              }}
            />
            {isReason && (
              <span style={{ color: "red", fontSize: "0.8rem" }}>
                {"Reason is required"}
              </span>
            )}
          </DialogContent>

          <DialogActions
            sx={{ justifyContent: "flex-end", paddingBottom: "16px" }}
          >
            <Button
              variant="outlined"
              size="small"
              onClick={handleCloseReasonDialog}
              sx={{
                marginRight: "10px",
                borderColor: "#a2a2a2",
                color: "#a2a2a2",
                textTransform: "none",
              }}
            >
              Cancel
            </Button>
            <Button
              variant={"outlined"}
              color={"warning"}
              size="small"
              onClick={handleChangeCommissionStatus}
              sx={{
                marginRight: "10px",
                borderColor: "#EB1313",
                textTransform: "none",
              }}
            >
              {commissionsStatus === "Rejected" ? "Reject" : "Hold"}
            </Button>
          </DialogActions>
        </Dialog>
      </Grid2>

      <Grid2>
        <Dialog
          open={openHistory}
          onClose={handleCloseHistory}
          scroll="paper"
          maxWidth="md"
          sx={{
            "& .MuiDialog-paper": {
              minHeight: "85vh",
              minWidth: "70vw",
            },
            marginLeft: "70px",
          }}
        >
          <DialogTitle variant="h6">
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ fontWeight: 600, fontSize: "18px" }}>
                Payment History
              </Typography>
              <CloseIcon
                sx={{ cursor: "pointer" }}
                onClick={handleCloseHistory}
              ></CloseIcon>
            </Box>
          </DialogTitle>
          <DialogContent dividers>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className="tableHeadersCell">Updated On</TableCell>
                    <TableCell className="tableHeadersCell">Installment Due Date</TableCell>
                    <TableCell className="tableHeadersCell">Name</TableCell>
                    <TableCell className="tableHeadersCell">Invoice No </TableCell>
                    <TableCell className="tableHeadersCell">Amount</TableCell>
                    <TableCell className="tableHeadersCell">Status</TableCell>
                    <TableCell className="tableHeadersCell">Remarks</TableCell>
                  </TableRow>
                </TableHead>

                {!showLoader ? (
                  history?.paymentHistory?.length > 0 ? (
                    <TableBody>
                      {history?.paymentHistory?.map((item, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            backgroundColor: index % 2 === 1 ? "#FAFAFA" : "inherit",
                            "&:hover": { backgroundColor: "#f1f1f1" },
                          }}
                        >
                          <TableCell className="tableBodyCell">
                            {dayjs(item.generatedDate).format('DD-MM-YYYY') || '-'}
                          </TableCell>

                          <TableCell className="tableBodyCell">
                            {dayjs(item.paymentDate).format('DD-MM-YYYY') || '-'}
                          </TableCell>

                          <TableCell className="tableBodyCell">
                            {item.generatedUserName || '-'}
                          </TableCell>

                          <TableCell className="tableBodyCell">
                            {item.invoiceNumber || '-'}
                            <Tooltip
                              title="Edit Invoice id"
                              placement="top"
                              slotProps={{
                                tooltip: {
                                  sx: {
                                    backgroundColor: "#0A0D12",
                                    borderRadius: "8px",
                                    padding: "8px 12px",
                                    boxShadow:
                                      "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                  },
                                },
                              }}>
                              <EditOutlinedIcon
                                sx={{ fontSize: 16, ml: 1, cursor: 'pointer' }}
                                onClick={(e) => handleOpen(e, item)}
                              />
                            </Tooltip>
                          </TableCell>

                          <TableCell className="tableBodyCell">
                            {item.paymentAmount || '-'}
                          </TableCell>

                          <TableCell className="tableBodyCell">
                            <StatusBadge status={item?.paymentStatus} />
                          </TableCell>

                          <TableCell className="tableBodyCell" sx={{ width: '20%' }}>
                            {item.remarks || "-"}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={10}>
                          <Typography className="emptydatas">No Data Found</Typography>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )
                ) : (
                  <TableCell colSpan={100}>
                    <Box className="tableloader">
                      <TableLoader />
                    </Box>
                  </TableCell>
                )}
              </Table>
            </TableContainer>
          </DialogContent>
          <DialogActions>
            <MUICancelButton onClick={handleCloseHistory} title="Close">
              Close
            </MUICancelButton>
          </DialogActions>
        </Dialog>
      </Grid2>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        PaperProps={{
          sx: {
            p: 2,
            width: 260,
            borderRadius: 2,
            boxShadow: 3,
            position: "relative",
            border: "1px solid #ddd",
            backgroundColor: "#fff",
          }
        }}
      >
        <Box
          sx={{
            position: "absolute",
            bottom: -10,
            left: 20,
            width: 0,
            height: 0,
            borderLeft: "10px solid transparent",
            borderRight: "10px solid transparent",
            borderTop: "10px solid #fff",
            filter: "drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.2))",
          }}
        />

        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          Current Invoice Number
        </Typography>

        <Typography
          sx={{
            backgroundColor: "#F5F6F7",
            p: 1,
            borderRadius: 1,
            mb: 2,
            fontWeight: 500,
            fontSize: '14px'
          }}
        >
          {selectedInvoice}
        </Typography>

        <TextField
          label="Invoice Number"
          fullWidth
          value={updatedInvoice}
          onChange={(e) => setUpdatedInvoice(e.target.value)}
          sx={{ mb: 2 }}
          InputProps={{
            sx: {
              fontSize: "14px",
            },
          }}
        />

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <MUICancelButton title='Close' size="small" variant="outlined" onClick={handleClose} sx={{ textTransform: 'none' }} >
            Close
          </MUICancelButton>
          <MUIButton title="Update"
            size="small"
            variant="contained"
            onClick={() => handleUpdateInoive()}
            sx={{ textTransform: 'none' }}
          >
            Update
          </MUIButton>
        </Box>
      </Popover>
    </Box>
  );
};

export default ViewCommissions;
